<template>

<div id="deleteUserModal" class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ $t("user.delete.title") }}</h5>
        <button type="button" class="btn-close" @click="cancel()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>{{ $t("user.delete.absolutely_sure") }}</p>
        <p v-if="user" v-html="$t('user.delete.action', {firstName: user.firstName, lastName: user.lastName})"></p>

        <div v-if="error" class="alert alert-danger" role="alert">
          {{error}}
        </div>        
      </div>
      <div class="modal-footer text-center">
        <button type="button" class="btn btn-danger" @click="removeUser()">{{ $t("user.delete.understand_consequences_label") }}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{ $t("user.delete.cancel_label") }}</button>
      </div>
    </div>
  </div>
</div>

</template>

<script>

import {Modal} from 'bootstrap';
import $ from 'jquery'

import userService from '@/services/userService';
import eventConfig from '@/configs/eventConfig';

export default {
  name: 'UserDeleteComponent',
  props: {
    userToDelete: Object
  },
  watch: 
  { 
    userToDelete: function() {
      if(this.userToDelete)
      {
        this.user = JSON.parse(JSON.stringify(this.userToDelete));
        this.openModal();
      }
    }
  },
  data: function () {
    return {
      user: null,
      error: null,
      deleteModal: null
    }
  },
  components: {
    
  },
  mounted () {
    this.deleteModal = new Modal($('#deleteUserModal'));
    
    this.eventDispatcher.on(eventConfig.UNAUTHORIZED, () => {
      this.cancel();
    });

  },
  methods: {
    cancel()
    {
      this.deleteModal.hide();
      this.$emit(eventConfig.CANCELED);
    },
    openModal()
    {
      this.error = null;
      this.deleteModal.show();
    },
    removeUser()
    {
      
        userService.delete(this.user).then(
          response => {
            this.deleteModal.hide();
            this.$emit(eventConfig.DELETED);
          },
          errors => {
            this.parseErrors(errors.response.data);
          }
        );
      
    },
    parseErrors(data)
    {
      
        this.error = (data.msg_code) ? this.$t(data.msg_code) : data.msg;
      
    }
  }
}
</script>